import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import AccountSettings from "./settingsStack/AccountSettings";
import SettingsHome from "./settingsStack/SettingsHome";
import ManageWorkspace from "./settingsStack/ManageWorkspace";
import Billing from "./settingsStack/Billing";
import SwitchWorkspace from "./settingsStack/SwitchWorkspace";
import ManageUsers from "./settingsStack/ManageUsers";
import UserList from "./settingsStack/UserList";
import Permissions from "./settingsStack/Permissions";
import { RoleProvider } from "../context/RoleContext";

const Settings = () => {
  let { path } = useRouteMatch();

  return (
    <RoleProvider>
      <Switch>
        <Route path={`${path}/userList`} component={UserList} />
        <Route path={`${path}/account`} component={AccountSettings} />
        <Route path={`${path}/billing`} component={Billing} />
        <Route
          path={`${path}/users/permissions`}
          component={Permissions}
        />
        <Route path={`${path}/users`} component={ManageUsers} />

        <Route path={`${path}/workspace`} component={ManageWorkspace} />
        <Route path={`${path}/switch`} component={SwitchWorkspace} />
        <Route path={`${path}/`} component={SettingsHome} />
      </Switch>
    </RoleProvider>
  );
};

export default Settings;
